<ftr-floating-tabs
  [tabs]="tabs"
  [colorSet]="floatingTabsColorSet.Primary"
  [selectedValue]="statusType$ | async"
  (onTabSelected)="onFilterSelectionChange($event)"
></ftr-floating-tabs>
